/*

  HEADS UP! THIS IS A GENERATED FILE!

  Changes done in this file will be overwritten on next generation from the code generator.

*/
import {
  DateRangePicker,
  NumberFilterInput,
  PipeStringFilter,
} from 'components/filters';
import {
  BrandSelect,
  CustomerSubUnitSelect,
  SupplierSelect,
} from 'components/Selects';
import {
  LabelInput,
  SecureFormsy,
  Select,
} from 'flaivy-react/components/inputs';
import RequiresRole from 'flaivy-react/components/RequiresRole';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { resolve as brandResolve } from '../../shared/actions/generated/brand.actions';
import { resolve as customerSubUnitResolve } from '../../shared/actions/generated/customer-sub-unit.actions';
/* eslint-enable */
import { resolve as supplierResolve } from '../../shared/actions/generated/supplier.actions';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  if (query.supplier) {
    resolvedQuery.supplier = await supplierResolve(query.supplier);
  }
  if (query.brand) {
    resolvedQuery.brand = await brandResolve(query.brand);
  }
  if (query.customerSubUnit) {
    resolvedQuery.customerSubUnit = await customerSubUnitResolve(
      query.customerSubUnit,
    );
  }
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function StockArticleFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;
    const newQuerySpecification = {
      ...querySpecification,
      [key]: _.get(value, 'id') || value,
    };
    const newResolvedQuery = { ...resolvedQuery, [key]: value };
    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.articleNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.supplierArticleNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.productCategory === 'undefined' && (
          <FormGroup>
            <Label>Kategori / Typ / Stil</Label>
            <PipeStringFilter
              name="productCategory"
              value={_.get(resolvedQuery, 'productCategory')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.supplier === 'undefined' && (
          <FormGroup>
            <Label>Leverantör</Label>
            <SupplierSelect
              defaultOptions={false}
              instanceId="select-supplier"
              name="supplier"
              value={_.get(resolvedQuery, 'supplier')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.brand === 'undefined' && (
          <FormGroup>
            <Label>Varumärke</Label>
            <BrandSelect
              defaultOptions={false}
              instanceId="select-brand"
              name="brand"
              value={_.get(resolvedQuery, 'brand')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.name === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.shortName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.image === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.images === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.VAT === 'undefined' && (
          <FormGroup>
            <Label>moms (%)</Label>
            <NumberFilterInput
              name="VAT"
              value={_.get(resolvedQuery, 'VAT')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.orderUnit === 'undefined' && (
          <FormGroup>
            <Label>Försäljningsenhet</Label>
            <Select
              type="string"
              instanceId="select-orderUnit"
              name="orderUnit"
              value={_.get(resolvedQuery, 'orderUnit')}
              onChange={handleChange}
              options={[
                { label: 'förpackning', value: 'package' },
                { label: 'styck', value: 'single' },
                { label: 'vikt', value: 'weight' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.colliSize === 'undefined' && (
          <FormGroup>
            <Label>Antal styck i förpackning</Label>
            <NumberFilterInput
              name="colliSize"
              value={_.get(resolvedQuery, 'colliSize')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.volume === 'undefined' && (
          <FormGroup>
            <Label>Volym per styck (liter)</Label>
            <NumberFilterInput
              name="volume"
              value={_.get(resolvedQuery, 'volume')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.alcoholPercentage === 'undefined' && (
          <FormGroup>
            <Label>Alkoholprocent</Label>
            <NumberFilterInput
              name="alcoholPercentage"
              value={_.get(resolvedQuery, 'alcoholPercentage')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.alcoholTaxPaid === 'undefined' && (
          <FormGroup>
            <Label>Alkoholskatt betalad (kräver inte EMCS)</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'alcoholTaxPaid') === undefined}
                onClick={() => {
                  handleChange('alcoholTaxPaid', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'alcoholTaxPaid') === true ||
                  _.get(resolvedQuery, 'alcoholTaxPaid') === 'true'
                }
                onClick={() => {
                  handleChange('alcoholTaxPaid', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'alcoholTaxPaid') === false ||
                  _.get(resolvedQuery, 'alcoholTaxPaid') === 'false'
                }
                onClick={() => {
                  handleChange('alcoholTaxPaid', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.alcoholTaxClass === 'undefined' && (
          <FormGroup>
            <Label>Skatteklass</Label>
            <Select
              instanceId="select-alcoholTaxClass"
              name="alcoholTaxClass"
              value={_.get(resolvedQuery, 'alcoholTaxClass', '')}
              onChange={handleChange}
              options={[
                {
                  value: 'Alcoholfree',
                  label: 'Utan alkohol' || 'Alcoholfree',
                },
                { value: 'Beer', label: 'Öl' || 'Beer' },
                {
                  value: 'Wine',
                  label: 'Vin och andra jästa drycker än vin och öl' || 'Wine',
                },
                { value: 'MidRange', label: 'Mellanklass' || 'MidRange' },
                { value: 'Spirits', label: 'Sprit' || 'Spirits' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.requiresAlcoholPermit === 'undefined' && (
          <FormGroup>
            <Label>Kräver alkoholtillstånd</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresAlcoholPermit') === undefined
                }
                onClick={() => {
                  handleChange('requiresAlcoholPermit', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresAlcoholPermit') === true ||
                  _.get(resolvedQuery, 'requiresAlcoholPermit') === 'true'
                }
                onClick={() => {
                  handleChange('requiresAlcoholPermit', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresAlcoholPermit') === false ||
                  _.get(resolvedQuery, 'requiresAlcoholPermit') === 'false'
                }
                onClick={() => {
                  handleChange('requiresAlcoholPermit', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.container === 'undefined' && (
          <FormGroup>
            <Label>Förpackningstyp</Label>
            <Select
              type="string"
              instanceId="select-container"
              name="container"
              value={_.get(resolvedQuery, 'container')}
              onChange={handleChange}
              options={[
                { label: 'Burk', value: 'Can' },
                { label: 'Flaska', value: 'Bottle' },
                { label: 'Fat', value: 'Keg' },
                { label: 'Tetra', value: 'Tetra' },
                { label: 'Pappburk', value: 'Paper' },
                { label: 'Bag-in-box/Ståpåse', value: 'BIB' },
                { label: 'Påse', value: 'Bag' },
                { label: 'Pet', value: 'Pet' },
                { label: 'Ask', value: 'Box' },
                { label: 'Kruka', value: 'Pot' },
                { label: 'Kartong', value: 'Carton' },
                { label: 'Dunk', value: 'Plastic can' },
                { label: 'Konserv', value: 'TinCan' },
                { label: 'Annat', value: 'Other' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.markedAsOutOfStock === 'undefined' && (
          <FormGroup>
            <Label>Markerad som slut</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'markedAsOutOfStock') === undefined
                }
                onClick={() => {
                  handleChange('markedAsOutOfStock', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'markedAsOutOfStock') === true ||
                  _.get(resolvedQuery, 'markedAsOutOfStock') === 'true'
                }
                onClick={() => {
                  handleChange('markedAsOutOfStock', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'markedAsOutOfStock') === false ||
                  _.get(resolvedQuery, 'markedAsOutOfStock') === 'false'
                }
                onClick={() => {
                  handleChange('markedAsOutOfStock', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isCampaign === 'undefined' && (
          <FormGroup>
            <Label>Kampanj</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'isCampaign') === undefined}
                onClick={() => {
                  handleChange('isCampaign', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isCampaign') === true ||
                  _.get(resolvedQuery, 'isCampaign') === 'true'
                }
                onClick={() => {
                  handleChange('isCampaign', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isCampaign') === false ||
                  _.get(resolvedQuery, 'isCampaign') === 'false'
                }
                onClick={() => {
                  handleChange('isCampaign', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.campaignPrice === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.active === 'undefined' && (
          <FormGroup>
            <Label>Aktiverad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'active') === undefined}
                onClick={() => {
                  handleChange('active', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === true ||
                  _.get(resolvedQuery, 'active') === 'true'
                }
                onClick={() => {
                  handleChange('active', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === false ||
                  _.get(resolvedQuery, 'active') === 'false'
                }
                onClick={() => {
                  handleChange('active', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isNotForPublishing === 'undefined' && (
          <FormGroup>
            <Label>Skall aldrig publiceras</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isNotForPublishing') === undefined
                }
                onClick={() => {
                  handleChange('isNotForPublishing', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isNotForPublishing') === true ||
                  _.get(resolvedQuery, 'isNotForPublishing') === 'true'
                }
                onClick={() => {
                  handleChange('isNotForPublishing', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isNotForPublishing') === false ||
                  _.get(resolvedQuery, 'isNotForPublishing') === 'false'
                }
                onClick={() => {
                  handleChange('isNotForPublishing', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isPublishedOnOurStore === 'undefined' && (
          <FormGroup>
            <Label>Publicerad på Flaivy.com</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnOurStore') === undefined
                }
                onClick={() => {
                  handleChange('isPublishedOnOurStore', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnOurStore') === true ||
                  _.get(resolvedQuery, 'isPublishedOnOurStore') === 'true'
                }
                onClick={() => {
                  handleChange('isPublishedOnOurStore', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnOurStore') === false ||
                  _.get(resolvedQuery, 'isPublishedOnOurStore') === 'false'
                }
                onClick={() => {
                  handleChange('isPublishedOnOurStore', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isPublishedOnWhitelabel === 'undefined' && (
          <FormGroup>
            <Label>Publicerad på egen marknadsplats</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnWhitelabel') === undefined
                }
                onClick={() => {
                  handleChange('isPublishedOnWhitelabel', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnWhitelabel') === true ||
                  _.get(resolvedQuery, 'isPublishedOnWhitelabel') === 'true'
                }
                onClick={() => {
                  handleChange('isPublishedOnWhitelabel', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnWhitelabel') === false ||
                  _.get(resolvedQuery, 'isPublishedOnWhitelabel') === 'false'
                }
                onClick={() => {
                  handleChange('isPublishedOnWhitelabel', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isPublishedOnPro === 'undefined' && (
          <FormGroup>
            <Label>Publicerad på Qvanti (Inköpssystem)</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'isPublishedOnPro') === undefined}
                onClick={() => {
                  handleChange('isPublishedOnPro', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnPro') === true ||
                  _.get(resolvedQuery, 'isPublishedOnPro') === 'true'
                }
                onClick={() => {
                  handleChange('isPublishedOnPro', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnPro') === false ||
                  _.get(resolvedQuery, 'isPublishedOnPro') === 'false'
                }
                onClick={() => {
                  handleChange('isPublishedOnPro', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isPublishedOnStockfiller === 'undefined' && (
          <FormGroup>
            <Label>Publicerad på Stockfiller</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnStockfiller') === undefined
                }
                onClick={() => {
                  handleChange('isPublishedOnStockfiller', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnStockfiller') === true ||
                  _.get(resolvedQuery, 'isPublishedOnStockfiller') === 'true'
                }
                onClick={() => {
                  handleChange('isPublishedOnStockfiller', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isPublishedOnStockfiller') === false ||
                  _.get(resolvedQuery, 'isPublishedOnStockfiller') === 'false'
                }
                onClick={() => {
                  handleChange('isPublishedOnStockfiller', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.storageTemperature === 'undefined' && (
          <FormGroup>
            <Label>Förvaringstemperatur</Label>
            <Select
              type="string"
              instanceId="select-storageTemperature"
              name="storageTemperature"
              value={_.get(resolvedQuery, 'storageTemperature')}
              onChange={handleChange}
              options={[
                { label: 'Fryst', value: 'frozen' },
                { label: 'Kyld', value: 'refrigerated' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.origin === 'undefined' && (
          <FormGroup>
            <Label>Ursprung</Label>
            <PipeStringFilter
              name="origin"
              value={_.get(resolvedQuery, 'origin')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.isAlwaysOrderable === 'undefined' && (
          <FormGroup>
            <Label>Alltid beställningsbar</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'isAlwaysOrderable') === undefined}
                onClick={() => {
                  handleChange('isAlwaysOrderable', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isAlwaysOrderable') === true ||
                  _.get(resolvedQuery, 'isAlwaysOrderable') === 'true'
                }
                onClick={() => {
                  handleChange('isAlwaysOrderable', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isAlwaysOrderable') === false ||
                  _.get(resolvedQuery, 'isAlwaysOrderable') === 'false'
                }
                onClick={() => {
                  handleChange('isAlwaysOrderable', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isBlockedForPurchaseOrders === 'undefined' && (
          <FormGroup>
            <Label>Spärrad för inköp/inleverans</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isBlockedForPurchaseOrders') ===
                  undefined
                }
                onClick={() => {
                  handleChange('isBlockedForPurchaseOrders', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isBlockedForPurchaseOrders') === true ||
                  _.get(resolvedQuery, 'isBlockedForPurchaseOrders') === 'true'
                }
                onClick={() => {
                  handleChange('isBlockedForPurchaseOrders', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isBlockedForPurchaseOrders') ===
                    false ||
                  _.get(resolvedQuery, 'isBlockedForPurchaseOrders') === 'false'
                }
                onClick={() => {
                  handleChange('isBlockedForPurchaseOrders', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.seal === 'undefined' && (
          <FormGroup>
            <Label>Förslutning</Label>
            <Select
              type="string"
              instanceId="select-seal"
              name="seal"
              value={_.get(resolvedQuery, 'seal')}
              onChange={handleChange}
              options={[
                { label: 'Champangekork', value: 'CROWN CORK CAP' },
                { label: 'Kapsyl', value: 'GLASS CAP' },
                { label: 'Naturkork', value: 'NATURAL CORK' },
                { label: 'Skruvkork', value: 'SCREW CAP' },
                { label: 'Syntetkork', value: 'SYNTHETIC CORK' },
                { label: 'Oklassificerad', value: 'UNCLASSIFIED' },
                { label: 'Okänd', value: 'UNIDENTIFIED' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        <RequiresRole requiredRoles={['super']}>
          {typeof immutableQuery.utilityArticle === 'undefined' && (
            <FormGroup>
              <Label>Specialartikel</Label>
              <br />
              <ButtonGroup>
                <Button
                  color="secondary"
                  active={_.get(resolvedQuery, 'utilityArticle') === undefined}
                  onClick={() => {
                    handleChange('utilityArticle', undefined);
                  }}
                >
                  Alla
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'utilityArticle') === true ||
                    _.get(resolvedQuery, 'utilityArticle') === 'true'
                  }
                  onClick={() => {
                    handleChange('utilityArticle', true);
                  }}
                >
                  Ja
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'utilityArticle') === false ||
                    _.get(resolvedQuery, 'utilityArticle') === 'false'
                  }
                  onClick={() => {
                    handleChange('utilityArticle', false);
                  }}
                >
                  Nej
                </Button>
              </ButtonGroup>
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole requiredRoles={['super']}>
          {typeof immutableQuery.purchaseAccount === 'undefined' && (
            <FormGroup>
              <Label>Purchase Account</Label>
              <NumberFilterInput
                name="purchaseAccount"
                value={_.get(resolvedQuery, 'purchaseAccount')}
                onChange={handleChange}
              />
            </FormGroup>
          )}
        </RequiresRole>

        {typeof immutableQuery.hasLongerDeliveryTime === 'undefined' && (
          <FormGroup>
            <Label>
              Längre leveranstid - visa som beställningsvara för kund
            </Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasLongerDeliveryTime') === undefined
                }
                onClick={() => {
                  handleChange('hasLongerDeliveryTime', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasLongerDeliveryTime') === true ||
                  _.get(resolvedQuery, 'hasLongerDeliveryTime') === 'true'
                }
                onClick={() => {
                  handleChange('hasLongerDeliveryTime', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasLongerDeliveryTime') === false ||
                  _.get(resolvedQuery, 'hasLongerDeliveryTime') === 'false'
                }
                onClick={() => {
                  handleChange('hasLongerDeliveryTime', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.hasDailyPrice === 'undefined' && (
          <FormGroup>
            <Label>Dagspris</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'hasDailyPrice') === undefined}
                onClick={() => {
                  handleChange('hasDailyPrice', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasDailyPrice') === true ||
                  _.get(resolvedQuery, 'hasDailyPrice') === 'true'
                }
                onClick={() => {
                  handleChange('hasDailyPrice', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasDailyPrice') === false ||
                  _.get(resolvedQuery, 'hasDailyPrice') === 'false'
                }
                onClick={() => {
                  handleChange('hasDailyPrice', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.labels === 'undefined' && (
          <FormGroup>
            <Label>Etiketter</Label>
            <LabelInput
              instanceId="select-labels"
              name="labels"
              value={_.get(resolvedQuery, 'labels')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

StockArticleFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

StockArticleFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function StockArticleFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <StockArticleFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

StockArticleFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

StockArticleFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { StockArticleFilterPanel, StockArticleFilterPanelModal };
